import React from "react";
import ActivityFormContainer from "../ActivityFormContainer";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";

const typeMap = {
  AITutor: "Interactive Learning Experience",
  AxioResource: "Resource",
  Assignment: "Assignment",
  Project: "Project",
  Review: "Review",
};

const EditActivityModalContainer = ({
  visible,
  onClose,
  onSave,
  error,
  isSubmitting,
  existingActivity = null,
  courseId,
}) => {
  const { isMedium } = useResponsiveScreen();

  const formattedActivityData = existingActivity
    ? {
        title: existingActivity.title,
        description: existingActivity.description,
        targetAudience: existingActivity.targetAudience,
        enableVideoInsight: existingActivity.enableVideoInsight || true,
        id: existingActivity.id,
        type: existingActivity.type || typeMap[existingActivity.__typename] || "Project",
        files: existingActivity.files || [],
        videoUrl: existingActivity.videoUrl || "",
        dueDate: existingActivity.dueDate || existingActivity.due_date || "",
        enableFileUpload: existingActivity.enableFileUpload || existingActivity.enableStudentFileUpload || false,
        context: existingActivity.context || "",
        rawObjectives: existingActivity.objectives,
        visualization: existingActivity.visualization,
        visualizationId: existingActivity.visualization?.id || null,
        videoPool: existingActivity.videoPool
          ? existingActivity.videoPool.map((video) => ({
              ...video,
              isTeacherAdded: video.isTeacherAdded === true,
            }))
          : [],
      }
    : null;

  const handleSave = async (activityData) => {
    try {
      const result = await onSave({
        ...activityData,
        id: existingActivity?.id,
      });

      // Call onClose after a successful save to properly reset the modal state
      handleClose();
      return result;
    } catch (error) {
      console.error("Error saving activity:", error);
      throw error;
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <ActivityFormContainer
      visible={visible}
      onClose={handleClose}
      onSave={handleSave}
      error={error}
      isSubmitting={isSubmitting}
      existingActivity={formattedActivityData}
      courseId={courseId}
      key={visible ? "modal-open" : "modal-closed"}
      id="edit-activity-modal"
    />
  );
};

export default EditActivityModalContainer;
